import React from "react";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { StaggerGroup, StaggerItem } from "@/components/shared/Reveal";
import { SERVICE_AREAS } from "@/data/site";

export const ServiceArea = () => {
  return (
    <section className="relative bg-brand text-white overflow-hidden py-24 lg:py-32" data-testid="service-area">
      <div className="grain absolute inset-0" />
      <div className="pointer-events-none absolute -bottom-32 -right-24 h-[420px] w-[420px] rounded-full bg-brand-accent/20 blur-3xl" />
      <div className="container-x relative">
        <SectionHeading
          dark
          className="mb-16"
          eyebrow="Where we deliver"
          title="From your street to the world."
          description="One network, four scales of coverage — moving you wherever you need to be."
        />

        <StaggerGroup className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {SERVICE_AREAS.map(({ icon: Icon, title, desc }, i) => (
            <StaggerItem key={title} className="h-full">
              <div
                className="group h-full rounded-3xl border border-white/10 bg-white/5 backdrop-blur-sm p-8 transition-colors duration-300 hover:bg-white/10"
                data-testid={`area-card-${title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              >
                <div className="flex items-center justify-between">
                  <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white/10 text-brand-sky group-hover:bg-brand-accent group-hover:text-white transition-colors duration-300">
                    <Icon className="h-7 w-7" />
                  </div>
                  <span className="font-heading font-extrabold text-3xl text-white/10">0{i + 1}</span>
                </div>
                <h3 className="mt-6 font-heading font-bold text-xl">{title}</h3>
                <p className="mt-2 text-sm text-white/70 leading-relaxed">{desc}</p>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
};
